/**
 * Gemello client di `logic/services/casse-info.ts`. Legge da `window.__casse__`
 * (popolato nel layout NJK via filtro `script_var`) il descrittore casse del
 * territorio corrente e lo espone come Record<codice, CassaInfo>.
 *
 * La mappa e' cached per durata pagina: il bundle non viene ri-eseguito tra
 * navigazioni (SPA-like) — eventuali cambi di territorio richiedono reload.
 */

import type { CassaInfo } from '@/types/casse/cassa-info';

declare global {
  interface Window {
    __casse__?: CassaInfo[];
  }
}

let cached: Record<string, CassaInfo> | null = null;

export function getCasseMap(): Record<string, CassaInfo> {
  if (cached) return cached;
  const list = Array.isArray(window.__casse__) ? window.__casse__ : [];
  const map: Record<string, CassaInfo> = {};
  for (const c of list) map[c.codice] = c;
  cached = map;
  return map;
}

export type { CassaInfo };
